import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Shop from '../components/shop/Shop'
import { SHOP_URL_FILTER_TYPE } from '../util/shop.helpers'

const ShopContainer = ({ isNftEnabled }) => {
  const { t } = useTranslation()

  const location = useLocation()

  const [filterBy, setFilterBy] = useState(
    location?.state?.action || SHOP_URL_FILTER_TYPE.SHOP
  )

  const handleChangeFilterMenu = ({ value }) => {
    setFilterBy(value)
  }

  return (
    <Shop
      t={t}
      onChangeFilterMenu={handleChangeFilterMenu}
      filterBy={filterBy}
      isNftEnabled={isNftEnabled}
    />
  )
}

export default ShopContainer
